export default __webpack_public_path__ + "ae4716719524eeca4e6d1f30208704eb.svg";